import cx from "classnames";

type IconSpritePropsType = {
  name: string;
  className?: string;
};
export default function IconSprite({ name, className }: IconSpritePropsType) {
  return (
    <svg fill="currentColor" width="1em" height="1em" className={cx("icon", className)}>
      <use href={`/images/sprite.svg#${name}`}></use>
    </svg>
  );
}
